import { createSlice } from '@reduxjs/toolkit';
import reducers from './reducers';
import selectors from './selectors';
import { storeName } from './consts';
import { SummaryStoreStateInitial } from './types';

const initialState: SummaryStoreStateInitial = {
  loading: 'idle',
  error: null,
  entity: null
};

export const summarySlice = createSlice({
  name: storeName,
  initialState,
  selectors,
  reducers
});

export const { updateLoadingStatus, updateSummary } =
  summarySlice.actions;

export const {
  selectLoading,
  selectSummary,
  selectPreorderCount,
  selectTotalPrice,
  selectIsCartInstallmentAvailable,
  selectIsERecipeAvailable,
  selectHasQuantity
} = summarySlice.selectors;

export default summarySlice.reducer;
